import React from "react";
// styled components
import { Title } from "./typographyStyle";

const Typography = ({
  weight,
  space,
  size,
  children,
  color,
  isOpenSubMenu,
  hover,
  lgsize,
  mdsize,
  align,
  primary,
  className,
  onClick,
  style,
  pre,
}) => {
  return (
    <Title
      space={space}
      size={size}
      weight={weight}
      color={color}
      isOpenSubMenu={isOpenSubMenu}
      hover={hover}
      lgsize={lgsize}
      mdsize={mdsize}
      align={align}
      primary={primary}
      className={className}
      onClick={onClick}
      style={style}
      pre={pre}
    >
      {children}
    </Title>
  );
};
export default Typography;
